import React from 'react'
import AdditionalOfferEditPanel from "../additionalOfferEdit/AdditionalOfferEditPanel";

function AdditionalOfferPlacedPanel(
    {
        panelRef,
        sectionId
    }) {
    return <AdditionalOfferEditPanel panelRef={panelRef} sectionId={sectionId} />
}

export default AdditionalOfferPlacedPanel;